import { GET_NOW_CONTENT, GET_NOW_CONTENT_SETTINGS, SET_NOW_CONTENT_DATA, UPDATE_NOW_CONTENT_SETTINGS } from '../actions/nowContentActions';

const headerContent = {
    t: 'HEADER',
    n: 'HEADER',
    ih: false,
    ch: [],
    api: null
};

const initialState = {
    nowContentIsRefreshing: false,
    nowContentSettingsIsFetching: false,
    nowContentSettingsIsUpdating: false,
    nowContent: [headerContent]
};

export function nowContent(state = initialState, action)
{
    switch (action.type)
    {
        case GET_NOW_CONTENT.pending:
        {
            return {
                ...state
                ,nowContentFetching: true
            };
        }
        case GET_NOW_CONTENT.fulfilled:
        {
            const nowContent = [headerContent, ...action.payload];
            return {
                ...state,
                nowContent,
                lastError: {},
                nowContentFetching: false
            };
        }

        case GET_NOW_CONTENT.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                nowContentFetching: false
            };
        }
        case GET_NOW_CONTENT_SETTINGS.pending:
        {
            return {
                ...state,
                nowContentSettingsIsFetching: true
            };
        }
        case GET_NOW_CONTENT_SETTINGS.fulfilled:
        {
            return {
                ...state,
                nowContentSettings: action.payload,
                getNowContentSettingsError: {},
                nowContentSettingsIsFetching: false
            };
        }

        case GET_NOW_CONTENT_SETTINGS.rejected:
        {
            return {
                ...state,
                nowContentSettings: undefined,
                getNowContentSettingsError: action.payload,
                nowContentSettingsIsFetching: false
            };
        }
        case UPDATE_NOW_CONTENT_SETTINGS.pending:
        {
            return {
                ...state,
                nowContentSettingsIsUpdating: true
            };
        }
        case UPDATE_NOW_CONTENT_SETTINGS.fulfilled:
        {
            return {
                ...state,
                nowContentSettings: action.payload,
                nowContentSettingsUpdateError: {},
                nowContentSettingsIsUpdating: false
            };
        }

        case UPDATE_NOW_CONTENT_SETTINGS.rejected:
        {
            return {
                ...state,
                nowContentSettingsUpdateError: action.payload,
                nowContentSettingsIsUpdating: false
            };
        }
        case SET_NOW_CONTENT_DATA: {
            const nowContent = [headerContent, ...action.payload];
            return{
                ...state,
                nowContent,
                lastError: {},
                nowContentFetching: false
            };
        }
        default:
            return state;
    }
}
